// Libs
import React, { Component } from 'react'
import { Row, Col } from '../../../../components/Elemental'
import { Document, Page } from 'react-pdf'
import _ from 'lodash'

// CSS
import './styles.scss'

// Components/Containers
import Button from '../../../../components/Button'
import Modal from '../../../../components/Modal'
import LoadingIcon from '../../../../components/LoadingIcon'
import Input from '../../../../components/Input'

// Contants
import { currency } from '../../../../constants/normalize'

class SpCasePageConfirm extends Component {
  state = {
    agreedValue: '',
    expectedValue: '',
    hadObligation: '',
    noProposal: false,
    archiveReason: null,
    archiveObservation: '',
    error: '',
    proposalValue: null,
    numPages: 0
  }

  loadingPDF = () => {
    return (
      <div className="sp-case-page-confirm__loading-pdf">
        <LoadingIcon type="grey" />
      </div>
    )
  }

  onDocumentLoadSuccess = (numPages) => {
    this.setState({ numPages: numPages._pdfInfo.numPages });
  }

  submit = (message, action, file, minutaId, agreedValue, hadObligation, archiveReason, archiveObservation, expectedValue, proposalValue) => {
    const { user: { role }, handleConfirm, proposalConfirmation } = this.props
    const { noProposal } = this.state
    const { getMoney } = this

    if (action === 'checkout') {
      if (!agreedValue || !hadObligation) {
        this.setState({ error: 'Campo Obrigatório' })
        return;
      }
    }

    if (action === 'archive' && role === 'lawyer' && archiveReason === 6) {
      if (!expectedValue) {
        this.setState({ error: 'Campo Obrigatório' })
        return;
      }
    }

    if (action === 'proposal-confirmation') {
      if (!proposalValue && !noProposal) {
        this.setState({ error: 'Campo Obrigatório' })
        return;
      }
    }

    handleConfirm(message, action, file, minutaId, agreedValue, hadObligation, archiveReason, archiveObservation, expectedValue, proposalValue)
  }

  render() {
    const {
      localLoading,
      user: {
        role,
        name
      },
      confirm: {
        visible,
        action,
        headline,
        message,
        buttonTitle1,
        buttonTitle2,
        file,
        minutaId
      },
      archiveReasons,
      handleContinue,
      proposalConfirmation,
      spCase } = this.props
    const { agreedValue, expectedValue, hadObligation, archiveReason, archiveObservation, error, proposalValue, noProposal } = this.state
    const { formatReal, submit } = this

    return (
      <Modal visible={visible}>
        <div className="sp-case-page-confirm">
          <Row>
            <Col className="sp-case-page-confirm__text">
              {(action !== 'archive-observation' && action !== 'archive') &&
                <p className="sp-case-page-confirm__hi">Olá, {name}</p>
              }
              <p className="sp-case-page-confirm__question">{headline}</p>
            </Col>
          </Row>
          {(!_.isEmpty(message) && action === 'new') &&
            <Row>
              <Col>
                <div className={message.createBy === role ?
                  `sp-case-page-confirm__message sp-case-page-confirm__message--status-${message.status} sp-case-page-confirm__message--sent` :
                  `sp-case-page-confirm__message sp-case-page-confirm__message--status-${message.status} sp-case-page-confirm__message--received`}>
                  <div className="sp-case-page-confirm__header">
                    <p>{message.name}</p>
                    <p>{`${message.date} - ${message.hour}`}</p>
                  </div>
                  <p className="sp-case-page-confirm__content">{message.text}</p>
                </div>
              </Col>
            </Row>
          }
          {action === 'archive-observation' &&
            <Row className="sp-case-page-confirm__archive-reason">
              <Col>
                {archiveReasons.map(reason => (
                  <label key={reason.value}>
                    <div
                      className={archiveReason == reason.value ?
                        'sp-case-page-confirm__radio sp-case-page-confirm__radio--checked' :
                        'sp-case-page-confirm__radio'}>
                      <span />
                    </div>
                    <input
                      hidden
                      type="radio"
                      name="archive-reason"
                      value={reason.value}
                      checked={archiveReason === reason.value}
                      onChange={(e) => this.setState({ archiveReason: Number(e.target.value) })} />
                    <p>{reason.label}</p>
                  </label>
                ))}
              </Col>
            </Row>
          }
          {action === 'archive' &&
            <Row>
              {(role !== 'lawyer' || archiveReason !== 6) &&
                <Col>
                  <textarea
                    placeholder="Escreva aqui o complemento."
                    value={archiveObservation}
                    onChange={(e) => this.setState({ archiveObservation: e.target.value })}
                    className="sp-case-page-confirm__justify" />
                </Col>
              }
              {role === 'lawyer' && archiveReason === 6 &&
                <Col>
                  <input
                    className={(error && !expectedValue) ? 'input__input input__input--error' : 'input__input'}
                    name="expectedValue"
                    placeholder="0.000,00"
                    value={expectedValue}
                    onChange={(e) => this.setState({ expectedValue: currency(e.target.value) })} />
                  {error && !expectedValue && <p className="input__error">{error}</p>}
                </Col>
              }
            </Row>
          }
          {(((action === 'upload minuta' || action === 'upload protocolo') && file) || action === 'finish') &&
            <Row>
              <Col>
                <div className="sp-case-page-confirm__file">
                  <Document
                    file={file}
                    onLoadError={e => console.log(e)}
                    onLoadSuccess={this.onDocumentLoadSuccess} >
                    {Array(this.state.numPages).fill('').map((item, index) => {
                      return (
                        <Page pageNumber={index + 1} scale={0.5} />
                      )
                    })}
                  </Document>
                </div>
              </Col>
            </Row>
          }
          {action === 'checkout' &&
            <Row className="sp-case-page-confirm__checkout">
              <Col md="50%">
                <p>Qual foi o valor total acordado?*</p>
                <input
                  className={(error && !agreedValue) ? 'input__input input__input--error' : 'input__input'}
                  name="agreedValue"
                  placeholder="0.000,00"
                  value={agreedValue}
                  onChange={(e) => this.setState({ agreedValue: currency(e.target.value) })} />
                {error && !agreedValue && <p className="input__error">{error}</p>}
                <p>*Incluindo honorários</p>
              </Col>
              <Col md="50%">
                <p>Houve obrigação de fazer?</p>
                <div>
                  <label>
                    <div
                      className={hadObligation === '1' ?
                        'sp-case-page-confirm__radio sp-case-page-confirm__radio--checked' :
                        'sp-case-page-confirm__radio'}>
                      <span />
                    </div>
                    <input
                      hidden
                      name="hadObligation"
                      type="radio"
                      value="1"
                      onChange={() => this.setState({ hadObligation: '1' })} />
                    Sim
                  </label>
                  <label>
                    <div
                      className={hadObligation === '0' ?
                        'sp-case-page-confirm__radio sp-case-page-confirm__radio--checked' :
                        'sp-case-page-confirm__radio'}>
                      <span />
                    </div>
                    <input
                      hidden
                      name="hadObligation"
                      type="radio"
                      value="0"
                      onChange={() => this.setState({ hadObligation: '0' })} />
                    Não
                  </label>
                </div>
                {error && !hadObligation && <p className="input__error">{error}</p>}
              </Col>
            </Row>
          }
          {(action === 'proposal-confirmation' && spCase.status !== 3) &&
            <Col className="sp-case-page-confirm__checkout">
              <Row md="50%">
                <p>Importante! Por favor, confirme o valor financeiro da proposta.*</p>
                <input
                  className={(error && !proposalValue) ? 'input__input input__input--error' : 'input__input'}
                  name="agreedValue"
                  placeholder="0.000,00"
                  value={proposalValue}
                  disabled={noProposal}
                  onChange={(e) => this.setState({ proposalValue: currency(e.target.value) })} />
                {error && <p className="input__error">{error}</p>}
                <p>*Incluindo honorários</p>
              </Row>
              <Row md="50%">
                <div>
                  <label>
                    <div
                      className={noProposal ?
                        'sp-case-page-confirm__checkbox sp-case-page-confirm__checkbox--checked' :
                        'sp-case-page-confirm__checkbox'}>
                      <span />
                    </div>
                    <input
                      hidden
                      name="noProposal"
                      type="radio"
                      value={noProposal}
                      onChange={() => this.setState({ noProposal: !noProposal })} />
                    A mensagem não possui valor financeiro
                  </label>
                </div>
              </Row>
            </Col>
          }
          <Row>
            <Col md="50%">
              <Button
                type={(action === 'archive-reason' || action === 'archive-observation' || action === 'archive') ? 'decline' : 'submit'}
                localLoading={localLoading}
                gutterTop={20}
                onClick={() => submit(message, action, file, minutaId, agreedValue, hadObligation, archiveReason, archiveObservation, expectedValue, proposalValue, noProposal)}>{buttonTitle1}</Button>
            </Col>
            <Col md="50%">
              <Button gutterTop={20} onClick={() => handleContinue(action)}>{buttonTitle2}</Button>
            </Col>
          </Row>
        </div>
      </Modal>
    )
  }
}

export default SpCasePageConfirm
